import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

if(localStorage.getItem('token')){
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
}else{
    delete axios.defaults.headers.common['Authorization'];
}

// user login API to validate the credential
export const loginService = async (email, password) => {
    try {
        const response = await axios.post(`${API_URL}/login`, {
            email,
            password
        });
        return response;
    } catch (err) {
        if (err.response) {
            // Server responded with a status code outside the 2xx range
            return {
                error: true,
                message: err.response.data?.message || 
                         `Login failed with status code ${err.response.status}. Please check your credentials.`,
                status: err.response.status,
                response: err.response
            };
        } else if (err.request) {
            // Request was made but no response was received
            console.log(err.request);
            return {
                error: true,
                message: "No response from the server. This could be due to network issues or server downtime. Please try again later.",
                status: null,
                response: null
            };
        } else {
            // Something happened in setting up the request
            return {
                error: true,
                message: `An unexpected error occurred while processing your request: ${err.message}`,
                status: null,
                response: null
            };
        }
    }
}

export const registerServices = async (payload) => {
    try {
        return await axios.post(`${API_URL}/register`, payload);
    } catch (err) {
        return {
            error: true,
            response: err.response
        };
    }
}

export const logoutService = async () => {
    try {
        return await axios.post(`${API_URL}/logout`);
    } catch (err) {
        return {
            error: true,
            response: err.response
        };
    }
}

export const verifyToken = async () => {
    try{
        return await axios.post(`${API_URL}/verify-token`);
    }catch(err){
        return {
            error: true,
            response: err.response
        };
    }
}